<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/sale/invoices">{{ $t("sale_invoice_list") }}</router-link>
      </li>
      <li class="breadcrumb-item active" aria-current="page">{{ $t("new") }}</li>
    </ol>
    <div class="x_header">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="$router.go(-1)"
      >
        <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t("back") }}
      </button>
      <b-btn variant="outline-primary no-bor" size="sm" @click="clickSaveHandler">
        <i class="fa fa-floppy-o" aria-hidden="true" /> {{ $t("save") }}
      </b-btn>
      <b-btn
        variant="outline-primary no-bor"
        size="sm"
        @click="clickSaveHandler('save_and_print')"
      >
        <i class="fa fa-floppy-o" aria-hidden="true" /> {{ $t("save_and_print") }}
      </b-btn>
    </div>
    <div class="x_body">
      <div class="card f_card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-3">
              <div
                class="form-group"
                :class="{ 'form-group-error': $v.invoice.CustomerId.$error }"
              >
                <label class="label-control blue">{{ $t("customer") }}</label>
                <div>
                  <CustomerDropdown
                    @select="customerSelected"
                    :v-add-new="true"
                    :value="invoice.CustomerName"
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label class="label-control blue">ប្រភេទវិក្កយបត្រ</label>
                <div>
                  <select
                    disabled
                    class="form-control form-control-sm"
                    type="text"
                    v-model="invoice.InvoiceType"
                    @input="onChangeInvoiceType($event.target.value)"
                  >
                    <option value="COMERCIAL">COMERCIAL INVOICE</option>
                    <option value="TAX">TAX INVOICE</option>
                    <option value="AVDTAX">ADVANCE TAX INVOICE</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="addresses.length > 0" class="col-sm-2">
              <div class="form-group">
                <label class="control-lable blue">{{ $t("branch") }}</label>
                <div>
                  <select
                    class="form-control form-control-sm"
                    v-model="invoice.CustomerAddressId"
                  >
                    <option value=""></option>
                    <option v-for="ret in addresses" :key="ret.Id" :value="ret.Id">
                      {{ ret.Name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                  <label class="control-label blue">{{ $t("date") }}</label
                  ><br />
                  <date-picker
                      v-model="date"
                      value-type="YYYY-MM-DD" 
                      format="DD-MM-YYYY"
                      type="date"
                      placeholder="Date"
                      @input="onChangeDocDate()"
                  ></date-picker>                  
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                  <label class="control-label blue">{{ $t("due_date") }}</label>
                  <br />
                  <date-picker
                      v-model="due_date"
                      value-type="YYYY-MM-DD" 
                      format="DD-MM-YYYY"
                      type="date"
                      placeholder="Due Date"
                  ></date-picker>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label class="control-lable blue">{{ $t("invoice_no") }}</label>
                <div>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="invoice.Num"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label class="control-label blue">{{ $t("payment_term") }}</label>
                <select
                  class="form-control form-control-sm"
                  v-model="invoice.PaymentTerm"
                >
                  <option v-for="ret in $paymentTerms()" :key="ret.id" :value="ret.id">
                    {{ $t(ret.lang) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-sm-12">
              <table class="table table-bordered table-sm no-bor">
                <thead>
                  <tr class="upper">
                    <th style="width: 30px"></th>
                    <th>{{ $t("item_name") }}</th>
                    <th>{{ $t("description") }}</th>
                    <th style="width: 120px">{{ $t("qty") }}</th>
                    <th style="width: 120px">{{ $t("unit_price") }}</th>
                    <th style="width: 120px">អ.ត.ប(VAT)</th>
                    <th class="text-right" style="width: 120px">{{ $t("total") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ret, index) in lines" :key="ret.Id">
                    <td style="width: 30px">
                      <button
                        type="button"
                        class="btn btn-danger btn-remove"
                        @click="removeLine(index)"
                      >
                        X
                      </button>
                    </td>
                    <td>
                      <AuthCompleted
                        :vLineNo="index"
                        :vAddNew="true"
                        @select="select($event, ret)"
                        :value="ret.ItemName"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="ret.Description"
                        :disabled="ret.ItemId == ''"
                      />
                    </td>
                    <td class="text-center">
                      <input
                        type="number"
                        class="form-control form-control-sm "
                        v-model="ret.Quantity"
                        :disabled="ret.ItemId == ''"
                        @keypress="$isKeyNumber"
                        @change="reCalculate"
                      />
                    </td>
                    <td class="text-right">
                      <input
                        type="number"
                        class="form-control form-control-sm no-spinner"
                        v-model="ret.Price"
                        :disabled="ret.ItemId == ''"
                        @keypress="$isKeyNumber"
                        @change="reCalculate"
                      />
                    </td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        v-model="ret.TaxLine"
                        @change="reCalculate"
                        :disabled="ret.ItemId == ''"
                      >
                        <option value="10" :selected="ret.TaxLine == 10">Yes</option>
                        <option value="0" :selected="ret.TaxLine == 0">No</option>
                      </select>
                    </td>
                    <td class="text-right">
                      <input
                        type="text"
                        class="form-control form-control-sm text-right"
                        :value="$money(ret.SubTotal)"
                        readonly
                      />
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th class="none-a"></th>
                    <th rowspan="5" class="v-top none-a">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm no-bor"
                        @click="addLine"
                      >
                        <i class="fa fa-plus" /> {{ $t("add_line") }}
                      </button>
                    </th>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-right none-a">សរុប / Total:</td>
                    <td style="width: 120px" class="text-right">
                      {{ $dollar(invoice.GrandTotal) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-right none-a">អាករលើតម្លៃបន្ថែម VAT (10%):</td>
                    <td style="width: 120px" class="text-right">
                      {{ $dollar(invoice.TaxVat) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-right none-a">សរុបរួម/Grand Total:</td>
                    <td class="text-right">{{ $dollar(invoice.TotalAmount) }}</td>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-right none-a">អត្រាប្តូរប្រាក់ប្រចាំថ្ងៃ:</td>
                    <td class="cell-input">
                      <input
                        type="text"
                        class="form-control form-control-sm text-right"
                        style="font-size: 14px; color: red"
                        v-int-only
                        v-model="invoice.ExchangeRate"
                        @blur="onPriceChange(ret)"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-right none-a">ចំនួនទឹកប្រាក់ជាលុយរៀល:</td>
                    <td class="text-right">
                      R
                      {{
                        $number(
                          invoice.TotalAmount
                            ? invoice.TotalAmount.toFixed(2) * invoice.ExchangeRate
                            : 0,
                          "0,0"
                        )
                      }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <br />
          <hr />
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="control-lable blue">{{ $t("noted") }}</label>
                <div>
                  <textarea
                    class="form-control form-control-sm"
                    v-model="invoice.Description"
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerFormModel ref="mCustomer" @done="done" :name="customerName" />
    <ItemFormModal ref="mItem" @done="doneItem" :name="itemName" />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { required } from "vuelidate/lib/validators";
import { AuthCompleted } from "../../Item";
import CustomerDropdown from "../../Customer/Dropdown";
import CustomerFormModel from "../../Customer/FormModal";
import { ItemFormModal } from "../../Item";
import { Sale } from "../../../shared/models/model";
export default {
  components: {
    AuthCompleted,
    CustomerDropdown,
    CustomerFormModel,
    ItemFormModal,
    DatePicker
  },
  data: function () {
    return {
      invoice: JSON.parse(JSON.stringify(Sale.invoiceHeader)),
      lines: [
        JSON.parse(JSON.stringify(Sale.invoiceLine)),
        JSON.parse(JSON.stringify(Sale.invoiceLine)),
        JSON.parse(JSON.stringify(Sale.invoiceLine)),
        JSON.parse(JSON.stringify(Sale.invoiceLine)),
        JSON.parse(JSON.stringify(Sale.invoiceLine)),
      ],
      add_item_line_no: null,
      date: this.$now().format("DD-MM-YYYY"),
      due_date: this.$now().format("DD-MM-YYYY"),
      actionLink: "invoice/save",
      types: [],
      isIncludeVat: false,
      addresses: [],
      customerName: "",
      itemName: "",
    };
  },
  created() {
    this.init();
  },
  validations: {
    invoice: {
      CustomerId: { required },
    },
  },
  methods: {
    init() {
      var loading = this.$loading.show();
      let id = this.$route.params.id;
      let req = {
        CompanyId: this.$store.state.company.Id,
      };
      if (!this.$isEmpty(id)) {
        this.actionLink = "invoice/update";
        req.Id = id;
      }
      this.$api()
        .post("invoice/init-form", req)
        .then((res) => {
          if (this.$isValid(res)) {
            let json = res.data.Json;
            this.invoice = json.Header;
            if(!this.invoice.PaymentTerm) this.invoice.PaymentTerm = 'Pay Later';
            if (this.invoice.CustomerId == "00000000-0000-0000-0000-000000000000")
              this.invoice.CustomerId = null;
            if (!this.$isEmpty(id)) {
              this.lines = json.Lines;
            }
            this.date = this.invoice.Date;
            this.due_date = this.invoice.DueDate;
            this.fetchExchangeRate(this.invoice);
          }
        })
        .finally(() => {
          loading.hide();
        });
    },
    onPriceChange() {
      this.reCalculate();
    },
    clickSaveHandler(type) {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.invoice.Date = this.date;
        this.invoice.DueDate = this.due_date;
        this.invoice.CompanyId = this.$store.state.company.Id;
        this.invoice.ClientId = this.$store.state.company.ClientId;
        let req_lines = this.lines.filter((el) => el.ItemId != "");
        if (req_lines.length == 0) {
          this.$swal.fire("សារបញ្ជាក់", "សូមធ្វើការជ្រើសរើសទំនិញយ៉ាងតិច១។", "warning");
        } else {
          var req = {
            Header: this.invoice,
            Lines: req_lines,
          };
          var loading = this.$loading.show();
          this.$api()
            .post(this.actionLink, req)
            .then((res) => {
              if (this.$isValid(res)) {
                if (type == "save_and_print") {
                  this.print(res.data.Json.Item);
                }
                this.$router.push("/sale/invoices");
              }
            })
            .finally(function () {
              loading.hide();
            });
        }
      }
    },
    select(item, line) {
      if (item.type == 3) {
        line.ItemId = item.data.Id;
        line.ItemName = item.data.Name;
        line.Price = item.data.Price;
        line.Cost = item.data.Cost;
        line.UomId = item.data.UomId;
        line.UomName = item.data.UomName;
        line.Description = item.data.SaleDesc;
        this.reCalculate();
      } else if (item.type == 1) {
        this.add_item_line_no = item.data.line_no;
        this.$refs.mItem.$refs.innermodal.show();
      } else if (item.type == 4) {
        this.lines[item.line_no].ItemId = item.Id;
        this.lines[item.line_no].ItemName = item.Name;
        this.lines[item.line_no].Price = item.Price;
        this.lines[item.line_no].Cost = item.Cost;
        this.lines[item.line_no].UomId = item.UomId;
        this.lines[item.line_no].UomName = item.UomName;
        this.lines[item.line_no].Description = item.SaleDesc;
      }
    },
    customerSelected(item) {
      if (item.type == 3) {
        this.invoice.CustomerId = item.data.Id;
        this.invoice.CustomerTypeId = item.data.CustomerTypeId;
        this.invoice.InvoiceType = item.data.InvoiceType;
        this.onChangeInvoiceType(item.data.InvoiceType);
      } else if (item.type == 1) this.$refs.mCustomer.$refs.innermodal.show();
    },
    reCalculate() {
      let grand = 0;
      let tax = 0;
      this.lines.map((item) => {
        item.SubTotal = item.Quantity * item.Price;
        item.TaxAmount = (item.Price * Number(item.TaxLine)) / 100;

        grand += item.SubTotal;
        tax += item.TaxAmount * item.Quantity;
      });
      this.invoice.GrandTotal = grand;
      this.invoice.TaxVat = tax;
      this.invoice.TotalAmount = grand + tax;
      this.invoice.IncludeTaxAmount = this.invoice.TotalAmount;
      this.invoice.Balance = this.invoice.TotalAmount;
    },
    addLine() {
      this.lines.push(JSON.parse(JSON.stringify(Sale.invoiceLine)));
    },
    removeLine(index) {
      this.lines.splice(index, 1);
      this.reCalculate();
    },
    done(e) {
      this.invoice.CustomerId = e.Id;
      this.invoice.CustomerName = e.Name;
      this.invoice.CustomerTypeId = e.CustomerTypeId;
      this.invoice.InvoiceType = e.InvoiceType;
      this.onChangeInvoiceType(e.InvoiceType);
    },
    doneItem(e) {
      if (this.add_item_line_no != null || this.add_item_line_no != undefined) {
        e.line_no = this.add_item_line_no;
        e.type = 4;
        this.select(e, "");
        this.add_item_line_no = null;
      }
    },
    print(item) {
      if (item.InvoiceType == "TAX")
        window.open("/print/taxinvoice/" + item.Id, "_blank");
      else window.open("/print/nontaxinvoice/" + item.Id, "_blank");
    },
    onChangeDocDate() {
      this.fetchExchangeRate(this.invoice);
    },
    fetchExchangeRate(req) {
      this.$api()
        .post("invoice/exchangerate-by-date", req)
        .then((res) => {
          if (this.$isValid(res)) {
            if (res.data.Json.Rate) this.invoice.ExchangeRate = res.data.Json.Rate.Value;
            else this.invoice.ExchangeRate = 0;
          }
        });
    },
    onChangeInvoiceType(value) {
      this.invoice.InvoiceType = value;
      this.$api()
        .post("invoice/confignum-by-invoice", this.invoice)
        .then((res) => {
          if (this.$isValid(res)) {
            this.invoice.Num = res.data.Json.Num;
          }
        });
    },
  },
};
</script>
<style scoped>
label {
  margin-bottom: 0;
}

</style>
